import React, { useState, useEffect, useMemo } from 'react';

import { Dialog, Card } from '@mui/material';
import { images, icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useIsMobile } from '../../helpers/customHooks';
import NewButton from '../Buttons/NewButton';

const SubscriptionModal = ({ show, onClose, type, info, cancelPlan }) => {
    const MOBILE = useIsMobile();
    const { t } = useTranslation();

    const extraInfo = useMemo(() => {
        return info?.features
            ?.filter(f => f?.extrainfo)
            .map(f => f.extrainfo) || [];
    }, [info]);

    const stoplight = (val) => {
        if (!val) return (
            <img src={icons.check} className="size_12" />
        )
        if (val === "green") return <img src={icons.stoplight_green} alt="" />;
        if (val === "yellow") return <img src={icons.stoplight_yellow} alt="" />;
        return <img src={icons.stoplight_red} alt="" />;
    };

    const additionalInfoContent = () => {
        return(
            <div className="w-100 h-100 grey-blue p-3">
                <div className="d-flex justify-content-between align-items-center">
                    <h3>{info?.name}</h3>
                    <img
                        className="cursor-pointer"
                        src={icons.close_gray}
                        onClick={onClose}
                        alt=""
                    />
                </div>

                {info?.features?.map((feature, index) => {
                    const infoIndex = extraInfo.indexOf(feature.extrainfo);
                    return (
                        <div key={index} className="d-flex align-items-center my-2">
                            {stoplight(feature?.color)}
                            <p className="ms-2 bold">
                                {feature?.value}
                                {feature?.extrainfo && <sup>{infoIndex + 1}</sup>}
                            </p>
                        </div>
                    );
                })}

                {extraInfo.map((info, index) => (
                    <p key={index} className="my-2 dark_grey">
                        <sup>{index + 1}</sup> {info}
                    </p>
                ))}
            </div>
        )
    }


    const deactivateContent = () => {
        return(
            <div className="w-100 h-100 grey-blue p-3">
                <div className="d-flex justify-content-between align-items-center">
                    <h3>{t("subscription.confirm_cancel")}</h3>
                    <img
                        className="cursor-pointer"
                        src={icons.close_gray}
                        onClick={onClose}
                        alt=""
                    />
                </div>
                <p className="grey-blue py-3">{t("subscription.confirm_cancel_sub")}</p>
                <div className="d-flex flex-row justify-content-between align-items-center mt-2">
                    <NewButton onClick={() => onClose()} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => cancelPlan()} className="bg-red p-3 rounded24 w-100 white-white ms-2 body bold">{t("settings.confirm")}</NewButton>
                </div>
            </div>
        )
    }

    const typeRender = () => {
        switch (type){
            case "additional":
                return additionalInfoContent()
            case "deactivate":
                return deactivateContent()
            default: return null
        }
    }

    return (
        <Dialog fullWidth={MOBILE} open={show} onClose={onClose}>
            <Card className="settings-dialog d-flex flex-column scrollable-y">
                {typeRender()}
            </Card>
        </Dialog>
    );
};

export default SubscriptionModal;